import { Injectable } from "@angular/core";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class ConfigService {

  constructor() {}

  static getConfig(prop: string) {
    if (environment[prop] !== undefined) {
      return environment[prop];
    } else {
      throw new Error("Config " + prop + " undefined");
    }
  }
}
